<template>
    <el-container>
        <el-header>
            <h1>OPPO定时批搭</h1>
        </el-header>
        <!-- <div class="ad-flow">
            <el-steps :active="activeStep" finish-status="success" direction="vertical" align-center>
                <el-step v-for="(item, index) in steps" :key="index" :title="item.name" :description="item.description"
                    :status="getStatus(item.status)">
                    <template #description>
                        <el-steps :active="item.activeChild" direction="vertical" align-center class="custom-steps">
                            <el-step v-for="(child, i) in item.children" :key="i" :title="child.title"
                                :description="child.description" :status="getStatus(child.status)" />
                        </el-steps>
                    </template>
                </el-step>
            </el-steps>
        </div> -->
        <el-main>
            <div class="plan-container">
                <el-form :model="form" label-position="right" class="demo-ruleForm">
                    <div data-v-da9757c6="" class="adgroup-item">账户信息</div>
                    <el-form-item label="查询指令:" label-width="160px">


                        <el-select v-model="btgjc" filterable clearable placeholder="请选择" @change="recordsChange">
                            <el-option v-for="(items, i) in listname" :key="i" :value="items.username">
                            </el-option>
                        </el-select>

                        <el-button type="primary" v-on:click="GetRo">刷新</el-button>
                        <el-select v-model="towName" placeholder="请选择">
                            <el-option v-for="(items, i) in two" :key="i" :value="items.twoname">
                            </el-option>
                        </el-select>
                        <el-button type="primary" v-on:click="findIds">查询</el-button>
                        <div class="item-orient">
                            <el-tag v-for="(item, index) in ids_list" :key="index" type="success">
                                {{ item.twoname }}
                            </el-tag>
                        </div>
                    </el-form-item>
                    <el-form-item label="创意样式" prop="type" label-width="152px">
                        <div class="el-form-item__content">
                            <el-select v-model="material_type" disabled>
                            </el-select>

                            <!-- 辅助操作按钮 -->
                            <el-button type="primary" plain style="margin-left: 16px;" @click="openStyleDialog">
                                点击选择
                            </el-button>

                        </div>
                    </el-form-item>
                    <el-form-item label="素材" prop="app_logo" label-width="152px">
                        <el-button type="primary" @click="handleMaterialsdialog">
                            选择素材
                        </el-button>
                    </el-form-item>
                </el-form>

            </div>

        </el-main>
      
        <el-dialog title="上传创意素材" :visible.sync="creativeMaterials" width="1160px" append-to-body>
            <div class="m-header" style="height: 600px;overflow-y: auto;" slot="title">
                <div class="m_header">
                    <el-tabs v-model="activeTab" type="card">
                        <el-tab-pane label="品牌LOGO" name="private">
                            <!-- 私有资源内容 -->
                            <!-- <div>APP_LOGO</div> -->
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="txfileList" :on-change="txhandleFileChange" :on-success="txhandleUploadSuccess"
                                :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择头像素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>


                        </el-tab-pane>
                        <el-tab-pane label="图片" name="img">
                            <!-- 公共资源内容 -->
                            <!-- <div>图片数量: {{ tpfileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    图片数量: {{ tpfileList.length }}
                                </div>
                                <el-button v-if="tpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllImages" class="clear-all-btn">
                                    清空全部
                                </el-button>
                            </div>
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="tpfileList" :on-change="tphandleFileChange" :on-success="tphandleUploadSuccess"
                                :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择图片素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="tphandlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click.stop="tphandleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>
                        </el-tab-pane>
                        <el-tab-pane label="视频封面" name="imgvideo">
                            <!-- 公共资源内容 -->
                            <!-- <div>图片数量: {{ videotpfileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    封面图片数量: {{ videotpfileList.length }}
                                </div>
                                <el-button v-if="videotpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllcoverImages" class="clear-all-btn">
                                    清空全部
                                </el-button>
                            </div>
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="videotpfileList" :on-change="videotphandleFileChange"
                                :on-success="tphandleUploadSuccess" :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择图片素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="videotphandlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete"
                                                @click.stop="videotphandleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>
                        </el-tab-pane>
                        <el-tab-pane label="视频" name="video">
                            <!-- 公共资源内容 -->
                            <!-- <div>视频数量:{{ videofileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    视频数量: {{ videofileList.length }}
                                </div>
                                <el-button v-if="videofileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllvideos" class="clear-all-btn">
                                    清空全部
                                </el-button>
                            </div>
                            <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true"
                                ref="upload" :file-list="videofileList" :on-change="videohandleFileChange"
                                :show-file-list="false">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">
                                    将文件拖到此处，或<em>点击上传</em>
                                </div>
                                <div class="el-upload__tip" slot="tip">
                                    支持 MP4 格式
                                </div>


                            </el-upload>
                            <div class="video-list">
                                <div class="video-item" v-for="(file, index) in videofileList"
                                    :key="file.uid || file.name || index">
                                    <div class="video-content">
                                        <span class="video-title">{{ file.name }}</span>
                                        <div class="video-thumbnail">
                                            <video :src="file.url" controls></video>
                                        </div>
                                        <el-button type="text" icon="el-icon-delete" @click="handleRemove2(file)"
                                            class="delete-btn"></el-button>
                                    </div>
                                </div>
                            </div>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>


        </el-dialog>
        <el-dialog title="选择创意样式" :visible.sync="createTypedialog" width="728px">
            <div class="el-form-item__content">
                <div class="style-selector">
                    <div class="category" v-for="category in styleCategories" :key="category.title">
                        <div class="category-title">{{ category.title }}</div>
                        <ul class="style-list">
                            <li v-for="style in category.styles" :key="style.value" :class="{
                                'selected': selectedStyle === style.value,
                                'recommended': style.recommended
                            }" @click="selectStyle(style)">
                                <!-- <div class="style-image"> -->
                                <img :src="style.image" class="bg-image">
                                <!-- </div> -->
                                <span class="style-info">{{ style.label }}</span>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createTypedialog = false">取 消</el-button>
                <el-button type="primary" @click="CreativeTypechang">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="20%" :src="dialogImageUrl" alt="">
        </el-dialog>
      
    </el-container>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import sha1 from 'js-sha1';
import { Base64 } from 'js-base64';
import qs from 'qs';
export default {
    data() {
        return {
            countdown: 0,
            countdownTimer: null,
            isLoading: false,
            listname: [],
            customColors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 40 },
                { color: '#5cb87a', percentage: 60 },
                { color: '#1989fa', percentage: 80 },
                { color: '#6f7ad3', percentage: 100 }
            ],
            showProgress: false,
            uploadPercent: 0,
            records: [],
            dingxiangbao: [],
            ids_list: [],
            selectedValue: [],
            selectedValue2: [],
            options: [], // 初始化空数组
            cascaderProps: {
                value: 'value',
                label: 'label',
                children: 'children',
                checkStrictly: false, // 如果需要严格模式
                multiple: true,
                emitPath: false
            },
            audience_list: [],
            btgjc: "",
            form: {
                extension_type: 1,       // 默认选中应用推广
                delivery_mode: 0,  // 营销场景
                dayLimit: 0,
                planName: '',              // 广告计划名称
                dayBudget: '',            // 投放预算
                switchPlan: 1,
                campaign_name: ''
            },

            extensionType_goal_group: [
                { value: 1, label: "网页推广" },
                { value: 2, label: "应用推广-应用下载" },
                { value: 3, label: "快应用推广" },
                { value: 7, label: "小程序推广" },
            ],
            ocpcTypeoptions: [
                { value: "14", label: "deeplink拉活", index: 1 },
                { value: "16", label: "deeplink回传激活", index: 1 },
                { value: "17", label: "deeplink回传注册", index: 1 },
                { value: "18", label: "deeplink应用付费", index: 1 },
                { value: "21", label: "deeplink应用内下单", index: 1 },
                { value: "6", label: "线索提交", index: 1 },


                { value: "22", label: "快应用/小程序付费", index: 3 },
                { value: "32", label: "快应用关键行为", index: 3 },
                { value: "51", label: "快游戏付费ROI1", index: 3 },
            ],
            form2: {
                Deeplinkstatus: 0,
                linkDeskFlag: 1,
                extensionFlow: '2',
                flowScene: 13,
                flowScene_list: [
                    // {
                    //     value: "1",
                    //     list: [{ value: "1", label: "全流量场景" },]
                    // },
                    {
                        value: "2",
                        list: [{ value: "13", label: "展示优选" },
                        { value: "6", label: "信息流" },]//1
                    }, {
                        value: "3",
                        list: [{ value: "12", label: "联盟通投" },
                        { value: "7", label: "Banner" },//1
                        { value: "8", label: "开屏" },//1
                        { value: "9", label: "插屏" },//1
                        { value: "10", label: "原生" },//1
                        { value: "11", label: "激励视频" },]
                    }
                ],
                pageType: '',



                flowScene_choose_list: [],
                dpaProductType: '0',
                Deeplinktype: 0,
                beginTime: [],
                billingType: '2',
                price: null,
                defaultSecondStage: 1,
                ocpcType: null,
                ocpcPrice: null,
                ocpcTypeoptions: [],

                deepOcpcType: null,
                deepOcpcPrice: 0,

                deepOcpcStatus: false,

                plan: '',
                adgroup_name: '',

            },
            pageType_list: [
                { value: "0", label: "自定义落地页" },//1
                { value: "4", label: "萤火虫建站" },//1
                { value: "7", label: "API线索投放" },//1
                { value: "6", label: "JS线索投放" }
            ],
            isSelecting: false,
            selectionStart: null,
            material_type: "",
            titlesString: '',
            titlesString2: '',

            form3: {

                buttonTxt: "",
                brandName: "",
                title: [],
                number: ''
            },
            buttonTxtOptions: [

                {
                    value: '打开',
                    label: '打开'
                }, {
                    value: '下载',
                    label: '下载'
                }, {
                    value: '去看看',
                    label: '去看看'
                }, {
                    value: '了解详情',
                    label: '了解详情'
                }, {
                    value: '参与活动',
                    label: '参与活动'
                }, {
                    value: '领取优惠',
                    label: '领取优惠'
                }, {
                    value: '立即打开',
                    label: '立即打开'
                }, {
                    value: '立即下载',
                    label: '立即下载'
                }, {
                    value: '立即查看',
                    label: '立即查看'
                }, {
                    value: '立即体验',
                    label: '立即体验'
                }, {
                    value: '立即申请',
                    label: '立即申请'
                }, {
                    value: '获取报价',
                    label: '获取报价'
                }, {
                    value: '立即领取',
                    label: '立即领取'
                }, {
                    value: '点击咨询',
                    label: '点击咨询'
                }, {
                    value: '下载抢购',
                    label: '下载抢购'
                }
            ],
            creativeMaterials: false, //素材
            txfileList: [],
            txfileCode: [],
            dialogImageUrl: '',
            activeTab: 'private',
            txuploadDialogVisible: false,
            txList: [],
            txuploading: false,
            dialogVisible: false,
            tpfileList: [],
            tpfileListcode: [],
            videotpfileListcode: [],
            videotpfileList: [],
            tpuploadDialogVisible: false,
            videofileList: [],
            selectedStyle: 'reward_video_vertical',
            styleCategories: [
                {
                    title: '视频类',
                    styles: [
                        {
                            value: '63',
                            label: '竖版视频',
                            image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                            recommended: true
                        },
                        {
                            value: '60',
                            label: '横版视频',
                            image: 'https://demo.nbweiou.cn/img/02.png'
                        },
                    ]
                },
                {
                    title: '图文类',
                    styles: [
                        {
                            value: '20',
                            label: '横版小图',
                            image: 'https://demo.nbweiou.cn/img/05.png'
                        },
                        {
                            value: '1',
                            label: '横版大图',
                            image: 'https://demo.nbweiou.cn/img/06.png'
                        },
                        {
                            value: ' 50',
                            label: '竖版大图',
                            image: 'https://demo.nbweiou.cn/img/06.png'
                        },
                        {
                            value: '30',
                            label: '横版组图',
                            image: 'https://demo.nbweiou.cn/img/07.png'
                        },
                        {
                            value: '71',
                            label: '图标大图',
                            image: 'https://demo.nbweiou.cn/img/09.png'
                        },


                    ]
                }
            ],
            styleCategorieslist: [
                {
                    name: "默认",
                    value: 0,
                    list: [
                        {
                            title: '视频类',
                            styles: [
                                {
                                    value: '63',
                                    label: '竖版视频',
                                    image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                    recommended: true
                                },
                                {
                                    value: '60',
                                    label: '横版视频',
                                    image: 'https://demo.nbweiou.cn/img/02.png'
                                },
                            ]
                        },
                        {
                            title: '图文类',
                            styles: [
                                {
                                    value: '20',
                                    label: '横版小图',
                                    image: 'https://demo.nbweiou.cn/img/05.png'
                                },
                                {
                                    value: '1',
                                    label: '横版大图',
                                    image: 'https://demo.nbweiou.cn/img/06.png'
                                },
                                {
                                    value: ' 50',
                                    label: '竖版大图',
                                    image: 'https://demo.nbweiou.cn/img/06.png'
                                },
                                {
                                    value: '30',
                                    label: '横版组图',
                                    image: 'https://demo.nbweiou.cn/img/07.png'
                                },
                                {
                                    value: '71',
                                    label: '图标大图',
                                    image: 'https://demo.nbweiou.cn/img/09.png'
                                },


                            ]
                        }
                    ]
                },
                {
                    name: "开屏",
                    value: 8,
                    list: [{
                        title: '视频类',
                        styles: [
                            {
                                value: '63',
                                label: '竖版视频',
                                image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                recommended: true
                            },
                            {
                                value: '60',
                                label: '横版视频',
                                image: 'https://demo.nbweiou.cn/img/02.png'
                            },
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            {
                                value: '5',
                                label: '开屏横图',
                                image: 'https://demo.nbweiou.cn/img/05.png'
                            },
                            {
                                value: '34',
                                label: '开屏竖图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: '71',
                                label: '图标大图',
                                image: 'https://demo.nbweiou.cn/img/09.png'
                            },


                        ]
                    }]
                },
                {
                    name: "原生",
                    value: 10,
                    list: [{
                        title: '视频类',
                        styles: [
                            {
                                value: '63',
                                label: '竖版视频',
                                image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                recommended: true
                            },
                            {
                                value: '60',
                                label: '横版视频',
                                image: 'https://demo.nbweiou.cn/img/02.png'
                            },
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            {
                                value: '20',
                                label: '横版小图',
                                image: 'https://demo.nbweiou.cn/img/05.png'
                            },
                            {
                                value: '1',
                                label: '横版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: ' 50',
                                label: '竖版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: '30',
                                label: '横版组图',
                                image: 'https://demo.nbweiou.cn/img/07.png'
                            },
                            {
                                value: '71',
                                label: '图标大图',
                                image: 'https://demo.nbweiou.cn/img/09.png'
                            },


                        ]
                    }]
                }, {
                    name: "信息流",
                    value: 6,
                    list: [{
                        title: '视频类',
                        styles: [
                            {
                                value: '63',
                                label: '竖版视频',
                                image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                recommended: true
                            },
                            {
                                value: '60',
                                label: '横版视频',
                                image: 'https://demo.nbweiou.cn/img/02.png'
                            },
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            {
                                value: '20',
                                label: '横版小图',
                                image: 'https://demo.nbweiou.cn/img/05.png'
                            },
                            {
                                value: '1',
                                label: '横版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: ' 50',
                                label: '竖版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: '30',
                                label: '横版组图',
                                image: 'https://demo.nbweiou.cn/img/07.png'
                            },
                        ]
                    }]
                },

            ],

            checkAll: true,
            isIndeterminate: false,
            adSlotisIndeterminate: false,
            adSlotcheckAll: true,
            createTypedialog: false,
            selectedStylelabel: "",
            allRestaurants: [],
            linesWithLimitError: [],
            linesWithLimitError2: [],
            startDate: '',
            endDate: '',
            campaign_id: '',
            videofileListcode: [],
            userId: '',
            two: '',
            towName: '',
            ids_list: [],

            activeStep: 0,
            steps: [
                {
                    name: '广告计划', status: 'wait',
                },
                { name: '广告组', status: 'wait' },
                { name: '广告创意', status: 'wait' },

            ],
            currentStep: 0,
            uploadPercent: 0,
            showProgress: false,
            currentIndeximg: 0,
            currentIndexvideo: 0,
            currentIndextext: 0,
            images: ["测试1", "测试2"],
            materialType: '',
            mixminvalue: false,
            mixminvaluelate: '轮询',
            isoldgroupprice: false,
            parsestatus: false,
            countdown: 0,
            countdownTimer: null
        };
    },
    created() {
        axios.get('https://test.nbweiou.cn/api/oppo/find_list_name', {
        }).then(
            res => {
                this.listname = res.data
                console.log(this.listname)
            }
        )
        this.extensionTypeChange(this.form.extension_type)
        this.changeextensionFlow(2)
        // this.userId = this.$route.query.userId

        // if (!this.userId) {
        //     // 使用Element UI的消息提示
        //     this.$message.warning('您得先登录')

        //     // 设置延迟跳转让用户看到提示
        //     setTimeout(() => {
        //         // 重定向到登录页面（外部链接）
        //         window.location.href = 'https://control.zjwec.cn/page/end/login.html'
        //     }, 1500)  // 1.5秒后跳转

        //     // 终止后续执行
        // }
        // // else {
        // //     // 如果获取到userId则正常加载
        // //     this.loadTemplates(1)
        // // }

        // this.handlelistByUbs()
        // this.getdingxiangbao()
        // this.updateCheckAllState
        // this.allRestaurants = this.restaurants.map(item => {
        //     return { value: item }
        // })

        // const apiData = {
        //     "audience_list": [this.audience_list], // 你的原始数据
        //     "category_id": 25,
        //     "category_name": "dmp推荐人群",
        //     "type": 3
        // };

        // // 转换数据结构

    },
    watch: {
        // 监听选中项变化

    },
    methods: {
        clearAllvideos() {
            this.videofileList = [];
            this.videofileListcode = []
            this.$message.success('已清空所有视频');
        },
        clearAllImages() {
            this.tpfileList = [];
            this.tpfileListcode = []
            this.$message.success('已清空所有图片');
        },
        clearAllcoverImages() {
            this.videotpfileList = [];
            this.videofileListcode = []
            this.$message.success('已清空封面图片');
        },
        getStatus(status) {
            switch (status) {
                case "success":
                    return "success";
                case "error":
                    return "error";
                case "active":
                    return "process";
                default:
                    return "wait";
            }
        },
        flowScenechange(string) {
            console.log(string);
            let res = this.styleCategorieslist.filter(item => item.value == string)
            console.log(res.length);
            console.log(res);

            if (res.length > 0) this.styleCategories = res[0].list
            else {
                this.styleCategories = this.styleCategorieslist[0].list
            }
        },
        async findIds() {

            this.ids_list = [],
                await axios.post('https://test.nbweiou.cn/api/oppo/get_ids', {
                    username: this.btgjc,
                    twoname: this.towName
                }).then(async res => {
                    this.ids_list = res.data;

                    const now = new Date();
                    const year = now.getFullYear();
                    const month = now.getMonth() + 1;
                    const pad = (n) => (n < 10 ? '0' + n : n);
                    const beginTime = Number(`${year}${pad(month)}01`);
                    const endTime = Number(`${year}${pad(month)}${pad(now.getDate())}`);

                    // 把所有请求收集到 promises
                    const promises = this.ids_list.map(async (item, index) => {
                        let time1 = Math.floor(Date.now() / 1000);
                        let sign = sha1(item.apiid + item.apikey + time1);
                        let token = Base64.encode(item.ownerid + "," + item.apiid + "," + time1 + "," + sign);

                        const config = {
                            headers: {
                                'Authorization': "Bearer " + token,
                                'Content-Type': "application/x-www-form-urlencoded"
                            }
                        };

                        const resp = await axios.post(
                            "apis/v3/group/page",
                            qs.stringify({
                                page: 1,
                                limit: 25,
                                needStats: 1,
                                beginTime,
                                endTime,
                                extensionTypes: null,
                                extensionFlows: null,
                                flowScenes: null,
                                advertiseTypes: null,
                                deleteFlag: 0,
                                showStatusSet: null,
                                orderByColumn: null,
                                insertTime: null,
                                asc: "DESC",
                                deliveryModes: ""
                            }),
                            config
                        );
                        if (resp.data.data.records.length > 0) {
                            this.ids_list[index].price = resp.data.data.records[0].price;
                            this.ids_list[index].ocpcPrice = resp.data.data.records[0].ocpxPrice || resp.data.data.records[0].ocpcPrice;
                        } else {

                            this.$message.warning('不能获取最新广告组出价')
                        }
                    });
                    // 等待所有请求完成
                    await Promise.all(promises);
                    // 确保 ids_list 更新后再打印
                    // console.log(this.ids_list);
                });
            console.log(this.ids_list);
        },
        async GetRo() {
            await axios.post('https://test.nbweiou.cn/api/oppo/get_vivo_user', {
                'username': this.btgjc
            }).then(
                res => {
                    this.two = res.data
                }
            )
        },
        PlacementTimehange(time) {
            if (time && time.length === 2) {
                const formatted = time.map(date => dayjs(date).format('YYYY-MM-DD'));
                console.log('格式化后:', formatted); // ['2038-01-19', '2038-01-25'] 之类
                // 如果你想保存
                // this.formattedPlacementTime = formatted;
                this.startDate = formatted[0]
                this.endDate = formatted[1]
            } else {
                console.log('未选择日期');
            }
        },
        changeextensionFlow(string) {
            // if(this.form.extension_type!=2)  {
            //     string=2
            //     this.form2.extensionFlow=2
            // }
            console.log(string);
            this.form2.flowScene_choose_list = this.form2.flowScene_list.find(item => item.value == string).list

            switch (string) {
                case "1":
                    this.form2.flowScene = '1'
                    break;
                case "2":
                    this.form2.flowScene = '13'
                    break;
                case "3":
                    this.form2.flowScene = '12'
                    break;

            }


        },
        extensionTypeChange(i) {
            console.log(i);
            const item = this.extensionType_goal_group.find(item => item.value == i);
            this.updatePlanName(item.label)
            console.log(i);
            if (i == 2) {
                this.form2.flowScene_list = [
                    {
                        value: "1",
                        list: [{ value: "1", label: "全流量场景" },]
                    },
                    {
                        value: "2",
                        list: [{ value: "13", label: "展示优选" },
                        { value: "6", label: "信息流" },]
                    }, {
                        value: "3",
                        list: [{ value: "12", label: "联盟通投" },
                        { value: "7", label: "Banner" },
                        { value: "9", label: "插屏" },
                        { value: "10", label: "原生" },
                        { value: "11", label: "激励视频" },]
                    }

                ]
            }
            // console.log(this.ocpcTypeoptions.filter(item=>item.index==i));
            this.form2 = { ...this.form2, ocpcTypeoptions: this.ocpcTypeoptions.filter(item => item.index == i) }
        },
        updatePlanName(typeText) {

            this.form.planName = `${typeText}`;
        },
        timesname() {
            const now = new Date();
            const formattedDate = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`;
            const formattedTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
            return `_${formattedDate}_${formattedTime}`
        },
        timesgetFun() {
            const now = new Date();
            const timestamp = now.getTime();
            return timestamp
        },
        async getdingxiangbao() {
            await axios.get('https://control.zjwec.cn/rgionPgk/list').then(res => {
                // console.log(res.data);
                this.dingxiangbao = res.data
            })
        },

        PlacementTimehange(time) {
            if (time && time.length === 2) {
                const formatted = time.map(date => dayjs(date).format('YYYY-MM-DD'));
                this.startDate = formatted[0]
                this.endDate = formatted[1]
            } else {
                console.log('未选择日期');
            }
        },
        ddddccc(e) {
            console.log(e);
            console.log(this.form2.dingxiangbao);
            let a = JSON.parse(this.form2.dingxiangbao)
            console.log(a);
        },
        async handleGetPlan() {
            const now = Date.now();
            const cooldownTime = 5000; // 5秒冷却时间

            // 检查是否在冷却时间内
            if (now - this.lastGetPlanTime < cooldownTime) {
                const remainingTime = Math.ceil((cooldownTime - (now - this.lastGetPlanTime)) / 1000);
                this.$message.warning(`请等待 ${remainingTime} 秒后再试`);
                return;
            }

            // 如果正在请求中，也直接返回
            if (this.isLoading) {
                this.$message.warning('请求正在进行中，请稍候');
                return;
            }

            this.isLoading = true;
            this.lastGetPlanTime = now;
            this.startCountdown();

            try {
                await this.createdanyuan();
                this.$message.success('操作成功');
            } catch (error) {
                console.error('操作失败:', error);
                this.$message.error('操作失败');
            } finally {
                // this.isLoading = false;
            }
        },
        startCountdown() {
            this.countdown = 5;

            // 清除之前的定时器
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
            }

            this.countdownTimer = setInterval(() => {
                this.countdown--;

                if (this.countdown <= 0) {
                    clearInterval(this.countdownTimer);
                    this.isLoading = false
                }
            }, 1000);
        },
        async queryWebsideId(token, ownerId) {
            const config = {
                headers: {
                    'Authorization': "Bearer " + token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            let parmm = {
                ownerId: ownerId,
                pageType: this.form2.pageType,
            }
            let parms
            await axios.post('apis/v2/communal/ad/sparkPageNew/list', qs.stringify(parmm), config
            ).then(res => {
                
                if (res.data.code == 0) {
                    parms = {
                        pageId: res.data.data[0].pageId,
                        pageUrl: res.data.data[0].pageUrl
                    }
                    // console.log(parse);
                } else {
                    this.$message.error('获取落地页失败')
                    
                }
            })
            return parms
        },
        async createdanyuan() {
            // if(this.form2.flowScene == 6 && this.form3.type == 50 || this.form2.flowScene == 10 && this.form3.type == 1 || this.form2.flowScene == 10 && this.form3.type == 50||(this.form2.flowScene == 6 && this.form3.type == 60) || (this.form2.flowScene == 6 && this.form3.type == 63)||(this.form2.flowScene == 10 && this.form3.type == 60) || (this.form2.flowScene == 10 && this.form3.type == 63)){
            //     if(this.txfileList.length == 0){
            //         this.$message.warning('请上传头像')
            //         return
            //     }

            // }
            console.log(this.ids_list);
            // this.tpfileListcode = []
            // this.txfileCode = []
            // this.videotpfileListcode = []
            // this.videofileListcode = []



            this.uploadPercent = 0
            this.showProgress = true
            let label = this.extensionType_goal_group.find(item => item.value == this.form.extension_type).label
            let planIdlist = []
            let planIdlisttoken = ''

            // if (this.isLoading) return;
            // this.isLoading = true;


            // let planidlist=[]
            for (let key = 0; key < this.ids_list.length; key++) {
                this.steps = [
                    {
                        name: '广告计划', status: 'wait',
                    },
                    { name: '广告组', status: 'wait' },
                    { name: '广告创意', status: 'wait' },

                ]
                this.activeStep = 0
                this.uploadPercent = Math.round((key / this.ids_list.length) * 100)
                this.$message.success(`正在搭建第${key}条指令`)
                console.log(`第${key}项：`);
                // console.log(label);
                this.updatePlanName(label)
                this.setStepStatus(0, 'process');
                let data = {
                    planName: this.ids_list[key].planName + '_' + this.form.planName + this.timesname() + this.form.campaign_name + this.timesgetFun(),
                    deliveryMode: this.form.delivery_mode,
                    extensionType: this.form.extension_type,
                    dayLimit: this.form.dayLimit,
                    ownerId: this.ids_list[key].zzownerid,
                }
                if (this.form.dayLimit == 1) {
                    data = { ...data, dayBudget: this.form.dayBudget * 100 }
                }
                let time1 = parseInt(new Date().getTime()) + '';
                time1 = parseInt(time1 / 1000);
                let sign = sha1(this.ids_list[key].apiid + this.ids_list[key].apikey + time1);
                let token = Base64.encode(this.ids_list[key].ownerid + "," + this.ids_list[key].apiid + "," + time1 + "," + sign);
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };
                planIdlisttoken = config

                this.tpfileListcode = []
                this.txfileCode = []
                this.videotpfileListcode = []
                this.videofileListcode = []
                //完成所有素材的上传
                if (this.txfileList.length > 0) {
                    let res = await this.uploadtxImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                if (this.tpfileList.length > 0) {
                    let res = await this.uploadImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                if (this.videotpfileList.length > 0 || this.videofileList.length > 0) {
                    if (this.videotpfileList.length != this.videofileList.length) return
                    let res = await this.uploadVideoImgFile(config, this.ids_list[key].zzownerid)
                    let res2 = await this.uploadVideoFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                await axios.post('apis/v3/plan/add', qs.stringify(data), config
                ).then(async res => {
                    console.log(res);
                    if (res.data.code == 1) {
                        this.$message({
                            showClose: true,
                            message: res.data.msg
                        });
                        return
                    } else if (res.data.code == 120110) {
                        this.$message({
                            showClose: true,
                            message: res.data.msg
                        });
                    } else if (res.data.code == 0) {

                        this.setStepStatus(0, 'success');
                        // if(!this.form.switchPlan){
                        let planIds = res.data.data.planId;
                        let status2 = this.form.switchPlan
                        await axios.post('apis/v3/plan/status', qs.stringify({ planIds, status2, ownerId: this.ids_list[key].zzownerid }), config
                        ).then(res => {
                            console.log(res.data)
                        })
                        //自动获取落地页信息
                        let parms
                        if (this.parsestatus) {
                            parms = await this.queryWebsideId(token, this.ids_list[key].zzownerid, key)
                        }
                        console.log(parms);

                        // }

                        planIdlist = [...planIdlist, res.data.data.planId]

                        let data2 = {
                            planId: res.data.data.planId,
                            adGroupName: this.ids_list[key].planName + '_' + this.form.planName + this.timesname() + this.form.campaign_name + this.timesgetFun(),
                            extensionFlow: this.form2.extensionFlow,
                            flowScene: this.form2.flowScene,
                            extensionType: this.form.extension_type,
                            targetId: this.ids_list[key].targetid,
                            billingType: this.form2.billingType,
                            price: this.isoldgroupprice && this.ids_list[key].price ? this.ids_list[key].price : this.form2.price * 100,
                            dayLimit: 0,
                            timeLimit: 0,
                            ownerId: this.ids_list[key].zzownerid,
                        }
                        if (this.form2.flowScene == 6 || this.form2.flowScene == 7 || this.form2.flowScene == 9 || this.form2.flowScene == 10 || this.form2.flowScene == 11) {
                            data2 = { ...data2, advertiseType: this.form2.dpaProductType }
                        }
                        if (this.form2.flowScene == 6 && this.form.extension_type == 3) {
                            data2 = { ...data2, linkDeskFlag: this.form2.linkDeskFlag }
                        }
                        if (this.form.extension_type == 3) {
                            data2 = {
                                ...data2,
                                pageType: this.form2.pageType,
                                pageUrl: this.ids_list[key].url.trim(),
                                instantAppId: this.ids_list[key].appid,
                                instantAppUrl: this.ids_list[key].haplink
                            }
                            if (this.parsestatus) {
                                data2 = {
                                    ...data2,
                                    pageUrl: parms.pageUrl.trim(),
                                    pageId: parms.pageId,
                                }
                            }
                        } else if (this.form.extension_type == 1) {
                            if (this.form2.Deeplinktype == 0) {
                                data2 = {
                                    ...data2,
                                    Deeplinktype: this.form2.Deeplinktype,
                                    pageType: this.form2.pageType,
                                    pageUrl: this.ids_list[key].url.trim(),
                                    // deepUrl: this.ids_list[key].haplink,

                                }
                                if (this.parsestatus) {
                                    data2 = {
                                        ...data2,
                                        pageUrl: parms.pageUrl.trim(),
                                        pageId: parms.pageId,
                                    }
                                }
                                if (this.form2.Deeplinkstatus) {
                                    data2 = {
                                        ...data2,
                                        // Deeplinktype:this.form2.Deeplinktype,
                                        // pageType: this.form2.pageType,
                                        // pageUrl: this.ids_list[key].url,
                                        deepUrl: this.ids_list[key].haplink,

                                    }
                                }
                            } else if (this.form2.Deeplinktype == 3) {
                                data2 = {
                                    ...data2,
                                    Deeplinktype: this.form2.Deeplinktype,
                                    pageType: this.form2.pageType,
                                    pageUrl: this.ids_list[key].url.trim(),
                                    instantAppId: this.ids_list[key].appid,
                                    instantAppUrl: this.ids_list[key].haplink,
                                    // pageId: 1200200596
                                }
                                if (this.parsestatus) {
                                    data2 = {
                                        ...data2,
                                        pageUrl: parms.pageUrl.trim(),
                                        pageId: parms.pageId,
                                    }
                                }
                            }

                        }
                        if (this.form2.billingType == 5) {
                            console.log(this.isoldgroupprice);
                            console.log(this.ids_list[key].ocpcPrice);
                            data2 = {
                                ...data2,
                                ocpcPrice: this.isoldgroupprice && this.ids_list[key].ocpcPrice ? this.ids_list[key].ocpcPrice : this.form2.ocpcPrice * 100,
                                ocpcType: this.form2.ocpcType,
                                defaultSecondStage: this.form2.defaultSecondStage,
                            }
                        }

                        console.log(data2);
                        this.setStepStatus(1, 'process');
                        await axios.post('apis/v3/group/add', qs.stringify(data2), config
                        ).then(async res => {
                            // console.log(?)
                            console.log(res.data.data)
                            if (res.data.code == 0) {
                                this.setStepStatus(1, 'success');
                                let data3 = {
                                    adGroupId: res.data.data.adGroupId,
                                    adPlanId: res.data.data.planId,
                                    adName: res.data.data.adGroupName,
                                    ownerId: this.ids_list[key].zzownerid,
                                }
                                if (this.form3.number < 0) return
                                this.setStepStatus(2, 'process');
                                await this.createoriginality(data3, token, key)
                            }
                            // console.log(res.data.data.adGroupId)
                            // this.ids_list[parms.id].groundId = res.data.data.adGroupId

                        })


                    }
                })








            }


            this.uploadPercent = 100
            setTimeout(() => {
                this.showProgress = false
            }, 31500)
            // this.isLoading = false;
        },
        isoldgrouppriceChang(e) {
            console.log(e);
            this.isIndeterminate = e
        },
        parsestatusChang(e) {
            console.log(e);
            this.parsestatus = e
        },
        setStepStatus(index, status) {
            this.steps[index].status = status;
            this.currentStep = index;
        },
        getBuildIndexes(countPerBuild) {
            if (!this.tpfileListcode.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndeximg + i) % this.tpfileListcode.length;
                indexes.push(index);
            }

            this.currentIndeximg = (this.currentIndeximg + countPerBuild) % this.tpfileListcode.length;

            return indexes;
        },
        getBuildvideoIndexes(countPerBuild) {
            if (!this.videofileListcode.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndexvideo + i) % this.videofileListcode.length;
                indexes.push(index);
            }

            this.currentIndexvideo = (this.currentIndexvideo + countPerBuild) % this.videofileListcode.length;

            return indexes;
        },
        getBuildtextIndexes(countPerBuild) {
            let res = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
            if (!res.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndextext + i) % res.length;
                indexes.push(index);
            }

            this.currentIndextext = (this.currentIndextext + countPerBuild) % res.length;

            return indexes;
        },



        async createoriginality(data, token, key) {
            const config = {
                headers: {
                    'Authorization': "Bearer " + token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            // if (this.videofileList.length > 0) {

            //     console.log(res);
            // }


            let imgcode = this.tpfileListcode
            let covercode = this.videotpfileListcode
            let videocode = this.videofileListcode

            let textlist = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line);

            if (this.mixminvalue) {
                imgcode = this.shuffleArray(imgcode)
                textlist = this.shuffleArray(textlist)
            }

            if (this.mixminvaluelate == "重复") {
                this.currentIndexvideo = 0
            }



            this.setStepStatus(2, 'success');


            if ((this.form2.flowScene == 6 && this.form3.type == 60) || (this.form2.flowScene == 6 && this.form3.type == 63) || (this.form2.flowScene == 10 && this.form3.type == 60) || (this.form2.flowScene == 10 && this.form3.type == 63)) {
                console.log(1);
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    // let imgindexlist=await this.getBuildIndexes(this.form3.number)
                    let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)

                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.videoMatIds = videocode[videoIndexelist[index]];
                    arr.brandLogoImgId = this.txfileCode[0]


                    addList.push(arr)
                }
                let add = {
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 6 && this.form3.type == 1 || this.form2.flowScene == 6 && this.form3.type == 50 || this.form2.flowScene == 10 && this.form3.type == 1 || this.form2.flowScene == 10 && this.form3.type == 50) {
                let addList = [];
                console.log(2);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    arr.brandLogoImgId = this.txfileCode[0]
                    arr.buttonTxt = this.form3.buttonTxt

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 10 && this.form3.type == 1) {
                console.log(3);
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    arr.buttonTxt = this.form3.buttonTxt
                    // arr.brandLogoImgId = this.txfileCode[0]

                    addList.push(arr)
                }
                let add = {
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 8 && this.form3.type == 5) {
                let addList = [];
                console.log(4);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)


                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];


                    addList.push(arr)
                }
                let add = {
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 8 && this.form3.type == 34) {
                console.log(5);
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];

                    addList.push(arr)
                }
                let add = {
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            }

        },
        shuffleArray(array) {
            const newArray = [...array]; // 创建副本，不影响原数组
            for (let i = newArray.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [newArray[i], newArray[j]] = [newArray[j], newArray[i]]; // 交换元素
            }
            return newArray;
        },
        removeEmptyFields(obj) {
            console.log(obj);

            return Object.fromEntries(Object.entries(obj).filter(([_, v]) =>
                v != null && v !== '' && !(Array.isArray(v) && v.length === 0)
            ))
        },
        async handlelistByUbs() {
            // this.ids_list = []
            // let arr = this.btgjc.split('\n').filter(line => line.trim());
            await axios.get('https://control.zjwec.cn/api/qttad/directives/all', {
                params: { userId: this.userId },
            }).then(res => {
                console.log(res);
                this.records = res.data
            });

        },
        async recordsChange(e) {

        },
        form3Numberchange(str) {
            console.log(str);
            // let res = this.getBuildtextIndexes(5)
            console.log(res);
        },
        // handlelistByUbs() {
        //     this.ids_list = []
        //     let arr = this.btgjc.split('\n').filter(line => line.trim());
        //     Promise.all(
        //         arr.map(item => {
        //             return axios.get('https://control.zjwec.cn/api/qttpd/listByUbs', {
        //                 params: { ubs: item },
        //             });
        //         })
        //     ).then(responses => {
        //         console.log('所有请求完成:', responses);
        //         let arr2 = []
        //         // 处理所有返回结果
        //         responses.forEach((res, index) => {
        //             console.log(`第${index + 1}个结果:`, res.data);
        //             arr2 = [...arr2, ...res.data]
        //         });
        //         console.log(arr2);
        //         axios.get('https://control.zjwec.cn/api/qtttoken/list').then(res2 => {
        //             console.log(res2.data);


        //             this.ids_list = arr2.map(customer => {
        //                 // 首先尝试用 khname 匹配
        //                 let matchedUser = res2.data.find(user => user.uname === customer.khname);



        //                 // 如果找到匹配用户，则添加 utoken
        //                 if (matchedUser) {
        //                     return {
        //                         ...customer,
        //                         utoken: matchedUser.utoken
        //                     };
        //                 }

        //                 // 没有匹配则保持原样
        //                 return customer;
        //             });
        //             this.getdmplist()
        //             // console.log(this.ids_list);

        //         })


        //     }).catch(error => {
        //         console.error('请求出错:', error);
        //     });
        //     console.log(this.ids_list);
        // },
        handleChange(value) {
            console.log('选中的值:', value);
            this.form2.audience_orient = value
        },
        handleChange2(value) {
            console.log('选中的值:', value);
            this.form2.audience_orient_filter = value
        },
        getdmplist() {
            console.log(this.ids_list);
            axios.get('/qttupapi/openapi/v1/conv/dmp/list', {
                params: {
                    account_id: this.ids_list[0].accountId
                },
                headers: {
                    'Content-Type': 'application/json',
                    'OGW_ACCESS_TOKEN': this.ids_list[0].utoken
                }
            })
                .then(res => {
                    console.log('请求成功:', res.data);

                    this.audience_list = res.data.data.filter(item => item.category_name == "dmp推荐人群")[0]
                    this.options = [{
                        value: this.audience_list.category_id,
                        label: this.audience_list.category_name,
                        children: this.audience_list.audience_list.map(item => ({
                            value: item.audience_id,
                            label: item.audience_name,
                            rawData: item // 保留原始数据
                        }))
                    }]
                    console.log(this.audience_list);
                })
                .catch(error => {
                    console.error('请求失败:', error);
                    if (error.response) {
                        console.log('错误状态码:', error.response.status);
                        console.log('错误响应数据:', error.response.data);
                    }
                });
        },

        handleInput2() {
            this.form3.second_title = this.titlesString2
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行

            console.log(this.form3.second_title);

            // 检查每一行是否在字数限制（8-23）内
            // this.linesWithLimitError = this.form3.title
            //     .map((line, index) => ({
            //         line: line,
            //         index: index + 1,
            //         length: line.length,
            //     }))
            //     .filter(item => item.length < 8 || item.length > 23) // 不在范围内的行
            //     .map(item => item.line); // 只返回文本内容



            // 如果存在超出字符数的行，更新提示信息
        },
        handleInput() {
            this.form3.title = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行

            console.log(this.form3.title);

            // 检查每一行是否在字数限制（8-23）内
            this.linesWithLimitError = this.form3.title
                .map((line, index) => ({
                    line: line,
                    index: index + 1,
                    length: line.length,
                }))
                .filter(item => item.length < 0 || item.length > 35) // 不在范围内的行
                .map(item => item.line); // 只返回文本内容



            // 如果存在超出字符数的行，更新提示信息
        },

        handleRemove2(file) {
            this.videofileListcode = []
            const tp = this.videofileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.videofileList.splice(tp, 1);
            }
        },
        videohandleFileChange(file, fileList) {
            console.log(file);
            if (file.status !== 'ready') return;
            this.videofileList = fileList.map(item => {
                return {
                    ...item,
                    url: item.url || URL.createObjectURL(item.raw), // 临时生成可用视频链接
                    file: item
                };
            });
            console.log(this.videofileList);
        },
        txReset() {
            this.txList = []
        },
        txhandleConfirmUpload() { },
        txhandleUploadSuccess() {
            this.$message.success('上传成功')
        },
        tphandleUploadSuccess() {
            this.$message.success('上传成功')
        },
        tphandleFileChange(file, txList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;
            this.tpfileList = [...this.tpfileList, {
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        videotphandleFileChange(file, txList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;
            this.videotpfileList = [...this.videotpfileList, {
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        tphandleRemove(file) {
            this.tpfileListcode = []
            const tp = this.tpfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.tpfileList.splice(tp, 1);
            }
            console.log(this.tpfileList);
            console.log(this.tpfileListcode);
        },
        videotphandleRemove(file) {
            this.videotpfileListcode = []
            const tp = this.videotpfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.videotpfileList.splice(tp, 1);
            }
            console.log(this.videotpfileList);
            console.log(this.videotpfileListcode);
        },
        tphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        videotphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        txhandleFileChange(file, txList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;

            console.log('准备上传文件:', file);
            this.txfileList = []
            this.txfileList = [{
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        async uploadtxImgFile(config, ownerId) {
            //品牌logo
            let img = this.txfileList[0]
            console.log(img);
            const formData = new FormData();
            formData.append('files', img.file.raw || img.file);
            formData.append('matSpecId', this.form3.type);
            formData.append('picType', "brandLogo");
            formData.append('ownerId', ownerId)

            return await axios.post('apis/v3/creative/material/communal/upload',
                formData, config).then(res => {
                    if (res.data.msg != 0) {
                        this.$message({ message: '品牌logo上传失败，问题是：' + res.data.msg, type: 'error' });
                        return
                    }
                    this.txfileCode = [res.data.data.id]
                    console.log(res.data);

                })
        },
        async uploadImgFile(config, ownerId) {
            try {
                const batchSize = 10; // 每批最多10个文件
                const delay = 2000; // 批次间隔2秒
                const totalFiles = this.tpfileList.length;
                const totalBatches = Math.ceil(totalFiles / batchSize);
                const allResults = [];
                let successfulUploads = 0;

                // 显示总进度


                // 分批处理
                for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                    const start = batchIndex * batchSize;
                    const end = Math.min(start + batchSize, totalFiles);
                    const currentBatch = this.tpfileList.slice(start, end);

                    // 显示当前批次信息
                    this.$message({
                        message: `正在上传第 ${batchIndex + 1}/${totalBatches} 批 (${start + 1}-${end}/${totalFiles})`,
                        type: 'info',
                        duration: 2000
                    });

                    // 创建当前批次的上传Promise数组
                    const batchPromises = currentBatch.map((img, indexInBatch) => {
                        const formData = new FormData();
                        formData.append('files', img.file.raw || img.file);
                        formData.append('matSpecId', this.form3.type);
                        formData.append('picType', "imgs");
                        formData.append('ownerId', ownerId);

                        return axios.post('apis/v3/creative/material/communal/upload', formData, config)
                            .then(res => {
                                if (res.data.msg !== "") {
                                    this.$message({
                                        message: `文件 ${start + indexInBatch + 1} 上传失败: ${res.data.msg}`,
                                        type: 'error',
                                        duration: 3000
                                    });
                                    return {
                                        ...res.data,
                                        error: true,
                                        originalIndex: start + indexInBatch
                                    };
                                }
                                successfulUploads++;
                                return res.data;
                            })
                            .catch(error => {
                                console.error(`文件 ${start + indexInBatch + 1} 上传失败:`, error);
                                this.$message({
                                    message: `文件 ${start + indexInBatch + 1} 上传失败: ${error.message || '网络错误'}`,
                                    type: 'error',
                                    duration: 3000
                                });
                                return {
                                    error: true,
                                    message: error.message,
                                    originalIndex: start + indexInBatch
                                };
                            });
                    });

                    // 等待当前批次完成
                    const batchResults = await Promise.all(batchPromises);
                    allResults.push(...batchResults);

                    // 如果不是最后一批，等待2秒
                    if (batchIndex < totalBatches - 1) {
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }

                console.log('所有上传结果:', allResults);

                // 处理结果
                const successfulResults = allResults.filter(r => !r.error && r.code === 0);
                const failedResults = allResults.filter(r => r.error || r.code !== 0);

                if (failedResults.length > 0) {
                    console.warn('有上传失败的文件:', failedResults);
                    this.$message({
                        message: `上传完成: ${successfulResults.length} 成功, ${failedResults.length} 失败`,
                        type: 'warning',
                        duration: 5000
                    });
                } else {
                    this.$message({
                        message: `所有 ${totalFiles} 个文件上传成功`,
                        type: 'success',
                        duration: 3000
                    });
                }

                // 收集成功的文件ID
                if (successfulResults.length > 0) {
                    const successfulIds = successfulResults
                        .filter(item => item.data && item.data.id)
                        .map(item => item.data.id);

                    this.tpfileListcode = [...this.tpfileListcode, ...successfulIds];

                    // 可选：显示成功上传的数量
                    this.$message({
                        message: `成功上传 ${successfulIds.length} 个文件，已添加到列表`,
                        type: 'success',
                        duration: 3000
                    });
                }

                return {
                    total: totalFiles,
                    successful: successfulResults.length,
                    failed: failedResults.length,
                    results: allResults
                };

            } catch (error) {
                console.error('上传过程中发生错误:', error);
                this.$message({
                    message: `上传失败: ${error.message || '请检查网络或接口'}`,
                    type: 'error',
                    duration: 5000
                });
                throw error; // 重新抛出错误以便外部处理
            }
        },
        async uploadVideoImgFile(config, ownerId) {
            try {
                const batchSize = 10; // 每批最多10个文件
                const delay = 2000; // 批次间隔2秒
                const totalFiles = this.videotpfileList.length;

                if (totalFiles === 0) {
                    this.$message({ message: '没有需要上传的封面图片', type: 'warning' });
                    return [];
                }

                const totalBatches = Math.ceil(totalFiles / batchSize);
                const allResults = [];
                let successfulUploads = 0;

                // 显示开始上传消息
                this.$message({
                    message: `开始上传 ${totalFiles} 个封面图片，共 ${totalBatches} 批`,
                    type: 'info',
                    duration: 3000
                });

                // 分批处理
                for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                    const start = batchIndex * batchSize;
                    const end = Math.min(start + batchSize, totalFiles);
                    const currentBatch = this.videotpfileList.slice(start, end);

                    // 显示当前批次信息
                    this.$message({
                        message: `正在上传第 ${batchIndex + 1}/${totalBatches} 批封面图片 (${start + 1}-${end}/${totalFiles})`,
                        type: 'info',
                        duration: 2000
                    });

                    // 创建当前批次的上传Promise数组
                    const batchPromises = currentBatch.map((img, indexInBatch) => {
                        const formData = new FormData();
                        formData.append('files', img.file.raw || img.file);
                        formData.append('matSpecId', this.form3.type);
                        formData.append('picType', "videoImg");
                        formData.append('ownerId', ownerId);

                        return axios.post('apis/v3/creative/material/communal/upload', formData, config)
                            .then(res => {
                                if (res.data.msg !== "") {
                                    this.$message({
                                        message: `封面图片 ${start + indexInBatch + 1} 上传失败: ${res.data.msg}`,
                                        type: 'error',
                                        duration: 3000
                                    });
                                    return {
                                        ...res.data,
                                        error: true,
                                        originalIndex: start + indexInBatch
                                    };
                                }

                                successfulUploads++;
                                return res.data;
                            })
                            .catch(error => {
                                console.error(`封面图片 ${start + indexInBatch + 1} 上传失败:`, error);
                                this.$message({
                                    message: `封面图片 ${start + indexInBatch + 1} 上传失败: ${error.message || '网络错误'}`,
                                    type: 'error',
                                    duration: 3000
                                });
                                return {
                                    error: true,
                                    message: error.message,
                                    originalIndex: start + indexInBatch
                                };
                            });
                    });

                    // 等待当前批次完成
                    const batchResults = await Promise.all(batchPromises);
                    allResults.push(...batchResults);

                    // 如果不是最后一批，等待2秒
                    if (batchIndex < totalBatches - 1) {
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }

                console.log('封面图片所有上传结果:', allResults);

                // 处理结果
                const successfulResults = allResults.filter(r => !r.error && r.code === 0);
                const failedResults = allResults.filter(r => r.error || r.code !== 0);

                if (failedResults.length > 0) {
                    console.warn('有上传失败的封面图片:', failedResults);
                    this.$message({
                        message: `封面图片上传完成: ${successfulResults.length} 成功, ${failedResults.length} 失败`,
                        type: failedResults.length === totalFiles ? 'error' : 'warning',
                        duration: 5000
                    });
                } else {
                    this.$message({
                        message: `所有 ${totalFiles} 个封面图片上传成功`,
                        type: 'success',
                        duration: 3000
                    });
                }

                // 收集成功的文件ID
                if (successfulResults.length > 0) {
                    const successfulIds = successfulResults
                        .filter(item => item.data && item.data.id)
                        .map(item => item.data.id);

                    // 添加到视频封面图片ID列表
                    this.videotpfileListcode = [...this.videotpfileListcode, ...successfulIds];

                    this.$message({
                        message: `成功上传 ${successfulIds.length} 个封面图片，已添加到列表`,
                        type: 'success',
                        duration: 3000
                    });
                }

                return {
                    total: totalFiles,
                    successful: successfulResults.length,
                    failed: failedResults.length,
                    results: allResults
                };

            } catch (error) {
                console.error('封面图片上传过程中发生错误:', error);
                this.$message({
                    message: `封面图片上传失败: ${error.message || '请检查网络或接口'}`,
                    type: 'error',
                    duration: 5000
                });
                throw error;
            }
        },
        async uploadVideoFile(config, ownerId) {
            try {
                const batchSize = 5; // 视频文件较大，每批最多5个文件
                const delay = 3000; // 视频上传时间可能较长，间隔3秒
                const totalFiles = this.videofileList.length;

                if (totalFiles === 0) {
                    this.$message({ message: '没有需要上传的视频文件', type: 'warning' });
                    return [];
                }

                const totalBatches = Math.ceil(totalFiles / batchSize);
                const allResults = [];
                let successfulUploads = 0;

                // 显示开始上传消息
                this.$message({
                    message: `开始上传 ${totalFiles} 个视频文件，共 ${totalBatches} 批`,
                    type: 'info',
                    duration: 4000
                });

                // 分批处理
                for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                    const start = batchIndex * batchSize;
                    const end = Math.min(start + batchSize, totalFiles);
                    const currentBatch = this.videofileList.slice(start, end);

                    // 显示当前批次信息
                    this.$message({
                        message: `正在上传第 ${batchIndex + 1}/${totalBatches} 批视频文件 (${start + 1}-${end}/${totalFiles})`,
                        type: 'info',
                        duration: 2500
                    });

                    // 创建当前批次的上传Promise数组
                    const batchPromises = currentBatch.map((video, indexInBatch) => {
                        const formData = new FormData();
                        formData.append('files', video.file.raw || video.file);
                        formData.append('matSpecId', this.form3.type);
                        formData.append('ownerId', ownerId);

                        // 添加上传进度监控（可选）
                        const source = axios.CancelToken.source();
                        const configWithProgress = {
                            ...config,
                            cancelToken: source.token,
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                                console.log(`视频 ${start + indexInBatch + 1} 上传进度: ${percentCompleted}%`);
                            }
                        };

                        return axios.post('apis/v3/creative/material/communal/upload', formData, configWithProgress)
                            .then(res => {
                                if (res.data.msg !== "") {
                                    this.$message({
                                        message: `视频文件 ${start + indexInBatch + 1} 上传失败: ${res.data.msg}`,
                                        type: 'error',
                                        duration: 4000
                                    });
                                    return {
                                        ...res.data,
                                        error: true,
                                        originalIndex: start + indexInBatch
                                    };
                                }

                                successfulUploads++;
                                this.$message({
                                    message: `视频文件 ${start + indexInBatch + 1} 上传成功`,
                                    type: 'success',
                                    duration: 2000
                                });
                                return res.data;
                            })
                            .catch(error => {
                                if (axios.isCancel(error)) {
                                    console.log(`视频 ${start + indexInBatch + 1} 上传被取消`);
                                    return {
                                        error: true,
                                        message: '上传已取消',
                                        originalIndex: start + indexInBatch
                                    };
                                }

                                console.error(`视频文件 ${start + indexInBatch + 1} 上传失败:`, error);
                                this.$message({
                                    message: `视频文件 ${start + indexInBatch + 1} 上传失败: ${error.message || '网络错误'}`,
                                    type: 'error',
                                    duration: 4000
                                });
                                return {
                                    error: true,
                                    message: error.message,
                                    originalIndex: start + indexInBatch
                                };
                            });
                    });

                    // 等待当前批次完成
                    const batchResults = await Promise.all(batchPromises);
                    allResults.push(...batchResults);

                    // 如果不是最后一批，等待3秒
                    if (batchIndex < totalBatches - 1) {
                        this.$message({
                            message: '等待3秒后继续下一批视频上传...',
                            type: 'info',
                            duration: 2000
                        });
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }

                console.log('所有视频上传结果:', allResults);

                // 处理结果
                const successfulResults = allResults.filter(r => !r.error && r.code === 0);
                const failedResults = allResults.filter(r => r.error || r.code !== 0);

                if (failedResults.length > 0) {
                    console.warn('有上传失败的视频文件:', failedResults);
                    this.$message({
                        message: `视频上传完成: ${successfulResults.length} 成功, ${failedResults.length} 失败`,
                        type: failedResults.length === totalFiles ? 'error' : 'warning',
                        duration: 5000
                    });
                } else {
                    this.$message({
                        message: `所有 ${totalFiles} 个视频文件上传成功`,
                        type: 'success',
                        duration: 3000
                    });
                }

                // 收集成功的视频文件ID
                if (successfulResults.length > 0) {
                    const successfulIds = successfulResults
                        .filter(item => item.data && item.data.id)
                        .map(item => item.data.id);

                    // 添加到视频文件ID列表
                    this.videofileListcode = [...this.videofileListcode, ...successfulIds];

                    this.$message({
                        message: `成功上传 ${successfulIds.length} 个视频文件，已添加到列表`,
                        type: 'success',
                        duration: 3000
                    });
                }

                return {
                    total: totalFiles,
                    successful: successfulResults.length,
                    failed: failedResults.length,
                    results: allResults
                };

            } catch (error) {
                console.error('视频上传过程中发生错误:', error);
                this.$message({
                    message: `视频上传失败: ${error.message || '请检查网络或接口'}`,
                    type: 'error',
                    duration: 5000
                });
                throw error;
            }
        },
        async uploadImgFile2(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            formData.append('file', img.file.raw || img.file);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res.data.data);
                const id = res.data.data.screen ? res.data.data.screen.id : res.data.data.id;

                this.tpfileListcode = [...this.tpfileListcode, id];


                console.log("--------------------------------------------------------");
                // console.log(res.data.data.screen.id);
                console.log("--------------------------------------------------------");
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        async uploadImgFile4(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            formData.append('file', img.file.raw || img.file);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res.data.data.id);
                this.tpfileListcode = [...this.tpfileListcode, res.data.data.id];
                console.log(this.tpfileListcode);
                console.log("--------------------------------------------------------");
                console.log(res.data.data.id);
                console.log("--------------------------------------------------------");
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        uploadImgFile3(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            formData.append('file', img.file.raw || img.file); // 确保传递的是原始文件对象
            formData.append('material_type', material_type);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res.data.data.id);
                this.videofileListcode = [...this.videofileListcode, res.data.data.id]
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        onChange(a, fileList) {
            console.log("11111");
            this.txuploadDialogVisible = true
        },
        handlePictureCardPreview: function (file) {
            console.log(file);
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 处理删除
        handleRemove(file) {
            const tp = this.txfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.txfileList.splice(tp, 1);
            }
            console.log(this.txfileList);
        },
        handleMaterialsdialog() {
            this.creativeMaterials = true
        },
        querySearch(queryString, cb) {
            // 过滤出匹配的建议项
            //   const results = queryString ? this.allRestaurants.filter(item => item.value.toLowerCase().includes(queryString.toLowerCase()): this.allRestaurants;
            const results = queryString ? this.allRestaurants.filter(item => item.value.toLowerCase().includes(queryString.toLowerCase())) : this.allRestaurants;
            // 调用回调函数返回建议列表
            cb(results)
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        CreativeTypechang() {
            console.log(this.selectedStyle);
            this.form3.type = this.selectedStyle
            this.createTypedialog = false
        },
        selectStyle(style) {
            console.log(style);
            this.selectedStyle = style.value
            console.log(style.value);
            console.log('style.value:', style.value, 'type:', typeof style.value);
            let materialType;

            switch (Number(style.value)) {
                case 63:
                    materialType = '竖版视频';
                    break;
                case 60:
                    materialType = '横版视频';
                    break;

                case 20:
                    materialType = '横版小图';
                    break;

                case 1:
                    materialType = '横版大图';
                    break;

                case 50:
                    materialType = '竖版大图';

                    break;

                case 30:
                    materialType = '横版组图';
                    break;
                case 71:
                    materialType = '图标大图';
                    break;

                default:
                    throw new Error(`未知的广告类型: ${style.value}`);
            }
            console.log(materialType);
            this.material_type = materialType
            this.selectedStylelabel = style.label
        },
        handleStyleChange(value) {
            this.$emit('change', value);
        },

        // 打开样式选择对话框（示例）
        openStyleDialog() {
            this.createTypedialog = true
        },
        handleinterestChange() {

        },







        handleSaveAndClose() {
            console.log('保存并关闭', this.form);
            // 这里添加保存逻辑
        },
        handleSaveAndCreate() {
            console.log('保存并创建单元', this.form);
            // 这里添加保存并创建逻辑
        },
        handleCancel() {
            console.log('取消');
            // 这里添加取消逻辑
        },
        querySearchAsync(queryString, cb) {
            // 这里实现地区搜索逻辑
            const results = this.regionOptions.filter(region =>
                region.label.includes(queryString)
            );
            cb(results);
        },
        handleSelect(item) {
            // 处理地区选择
            if (!this.form2.selectedRegions.includes(item.value)) {
                this.form2.selectedRegions.push(item.value);
            }
        },
        handleSelecttype(item) {
            console.log(item);
        },


        saveAndClose() {
            console.log('保存并关闭', this.form2);
            // 这里添加保存逻辑
        },
        saveAndCreate() {
            console.log('保存并创建创意', this.form2);
            // 这里添加保存并创建创意的逻辑
        },
        cancel() {
            console.log('取消');
            // 这里添加取消逻辑
        }

    },

};
</script>

<style scoped>
.ad-flow {
    position: fixed;
    height: 450px;
    top: 150px;
    /* left: 0; */
    right: 150px;
    padding: 15px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.el-step__title {
    font-size: 14px;
}

.select-container {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
}

.plan-container {
    text-align: left;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 50px;
}

.el-form-item__label {
    margin-right: 50px;
}

.demo-ruleForm {
    max-width: 800px;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-radio-group {
    margin-right: 15px;
}

.el-input {
    width: 280px;
}

.el-icon-info {
    color: #409EFF;
    cursor: pointer;
    font-size: 16px;
}

.el-button {
    margin-right: 10px;
}

.adgroup-container {
    padding: 20px;
    background-color: #fff;
}

.adgroup-form {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #eee; */
}

.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}

.media-specify-box,
.adslot-specify-box,
.region-custom-box,
.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.region-selection {
    margin-top: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.region-item {
    margin-bottom: 10px;
}

.age-checkbox-group,
.phone-price-group,
.network-group {
    display: inline-block;
    margin-left: 15px;
}

.orientBtn {
    margin-right: 10px;
}

.orientBtnActive {
    background-color: #409EFF;
    color: #fff;
}

.time-grid {
    margin-top: 15px;
    border: 1px solid #eee;
}

.time-grid-header {
    display: flex;
    border-bottom: 1px solid #eee;
    background-color: #f5f7fa;
}

.time-grid-header>div:first-child {
    width: 80px;
    padding: 10px;
    text-align: center;
}

.time-slots {
    display: flex;
    flex: 1;
}

.time-slots span {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
}

.time-grid-body {
    display: flex;
    flex-direction: column;
}

.time-row {
    display: flex;
    border-bottom: 1px solid #eee;
}

.time-row:last-child {
    border-bottom: none;
}

.day-label {
    width: 80px;
    padding: 10px;
    text-align: center;
    background-color: #f5f7fa;
}

.time-cells {
    display: flex;
    flex: 1;
}

.time-cell {
    flex: 1;
    height: 40px;
    border-right: 1px solid #eee;
    cursor: pointer;
}

.time-cell:last-child {
    border-right: none;
}

.time-cell.active {
    background-color: #409EFF;
}

.form-actions {
    margin-top: 30px;
    text-align: center;
}

.form-actions .el-button {
    margin: 0 10px;
}

.adgroup-item {
    color: #1890ff;
    line-height: 20px;
    font-size: 16px;
    border-left: 2px solid #1890ff;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.adgroup-item2 {
    color: #606266;
    line-height: 20px;
    font-size: 12px;
    border-left: 2px solid #606266;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.demo-ruleForm {
    max-width: 1000px;
}

.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
}

.time-grid {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 15px;
}

.time-grid-header {
    display: flex;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.header-label {
    width: 120px;
    padding: 10px;
    text-align: center;
    font-weight: bold;
}

.time-slots {
    flex: 1;
    display: flex;
}

.time-slots span {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
}

.time-grid-body {
    background-color: #fff;
}

.time-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
}

.time-row:last-child {
    border-bottom: none;
}

.day-label {
    width: 120px;
    padding: 10px;
    display: flex;
    align-items: center;
    border-right: 1px solid #ebeef5;
}

.day-label>>>.el-checkbox {
    width: 100%;
}

.time-cells {
    flex: 1;
    display: flex;
}

.time-cell {
    flex: 1;
    height: 40px;
    border-right: 1px solid #ebeef5;
    cursor: pointer;
}

.time-cell:last-child {
    border-right: none;
}

.time-cell:hover:not(.disabled) {
    background-color: #ecf5ff;
}

.time-cell.active:not(.disabled) {
    background-color: #409eff;
}

.time-cell.disabled {
    background-color: #f5f7fa;
    cursor: not-allowed;
}

.selected-times {
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.selected-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.selected-content {
    padding: 15px;
    background-color: #fff;
}

.selected-content div {
    margin-bottom: 5px;
    font-size: 14px;
}

.selected-content div:last-child {
    margin-bottom: 0;
}

.creative-item.idea-select {
    margin-bottom: 22px;
}

/* 成功状态样式 */
.creative-item.is-success .el-input__inner {
    border-color: #67c23a;
}

/* 必填项红色星号 */
.creative-item.is-required .el-form-item__label::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}

.creative-item.idea-select {
    margin-bottom: 22px;
}

.style-selector {
    width: 100%;
}

.category {
    margin-bottom: 20px;
}

.category-title {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    font-weight: bold;
}

.style-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0 -8px;
}

.style-list li {
    width: 20%;
    padding: 15px 8px;
    margin-left: 15px;
    margin-bottom: 16px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #e6e7eb;
}

.style-list li.selected {
    border: 1px solid #409eff;
    border-radius: 4px;
}

.style-list li.recommended {
    position: relative;
}

.style-image {}

.style-image img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.style-info {
    display: block;
    margin-top: 8px;
    text-align: center;
    font-size: 12px;
    color: #606266;
}

.selected-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
}

.style-tips {
    margin-top: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 12px;
    color: #606266;
}

.bg-image {
    width: 48px;
    height: 48px;
}

.video-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 0 -8px;
}

.video-item {
    flex: 0 0 calc(25% - 12px);
    /* 一行 4 个，减掉间距 */
    box-sizing: border-box;
}

.video-content {
    position: relative;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px;
    transition: all 0.3s;
}

.video-content:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.video-title {
    width: 70%;
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.video-thumbnail {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    /* 16:9 比例 */
    position: relative;
    overflow: hidden;
    background: #f5f7fa;
}

.video-thumbnail video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.delete-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    color: #f56c6c;
}

.adgroup-container {
    position: relative;
    min-height: 100vh;
    padding-bottom: 80px;
    /* 给底部栏留出空间 */
}

.adgroup-main {
    padding: 20px;
    /* 主要内容样式 */
}

.adgroup-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .adgroup-footer {
        flex-direction: column;
        padding: 10px;
    }

    .adgroup-footer .el-button {
        margin: 5px 0 !important;
        width: 100%;
    }
}

.custom-steps ::v-deep .el-step__head.is-success {
    /* 隐藏成功状态的图标 */
    display: none;
}

.custom-steps ::v-deep .el-step__title.is-success {
    /* 设置成功状态的文字颜色为蓝色 */
    color: #1890ff;
    font-weight: 500;
}

/* 可选：调整步骤条的布局，因为隐藏了图标 */
.custom-steps ::v-deep .el-step__main {
    margin-left: 0;
    padding-left: 0;
}

.custom-steps ::v-deep .el-step__line {
    /* 调整连接线的位置 */
    left: 8px;
}

.image-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    color: white;
}

.image-count {
    font-size: 14px;
    font-weight: 500;
}

.image-count i {
    margin-right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/oppo/ds/dingshi.vue